module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"retouchedPhotoAdded":"Ritocco caricato","downloadOriginal":"Scarica file originale","uploadRetouched":"Carica ritocco"}}')
  delete Component.options._Ctor
}
